import { useCreatePlaylistBusinessTypeForm } from "./use-create-playlist-business-type-form";
import { useCreatePlaylistBusinessType } from "../actions";
export var useCreatePlaylistBusinessTypeFromForm = function () {
    var _a = useCreatePlaylistBusinessTypeForm({
        title: "",
        image: null,
    }), title = _a.title, image = _a.image, validate = _a.validate;
    var _b = useCreatePlaylistBusinessType(), mutate = _b.mutate, isSuccess = _b.isSuccess, isLoading = _b.isLoading;
    var create = function () {
        var result = validate();
        if (result.type !== "success") {
            return;
        }
        var _a = result.validated, title = _a.title, file = _a.file;
        mutate({ title: title, image: file, isPublished: false });
    };
    var onSubmit = function (evt) {
        evt.preventDefault();
        create();
    };
    return {
        title: {
            value: title.value,
            error: title.error,
            onChange: title.onChange,
        },
        image: {
            value: image.value,
            error: image.error,
            reset: image.reset,
            onChange: image.onChange,
        },
        onSubmit: onSubmit,
        isSuccess: isSuccess,
        isLoading: isLoading,
    };
};
